import { MessageDescriptor } from 'react-intl';
import { get } from 'lodash-es';

export const getTitle = (
  titleEn: string,
  titleCn: string,
  formatTitle: string | MessageDescriptor,
  locale: string,
  formatMessage: (message: MessageDescriptor) => string,
): string => {
  const title = locale === 'en-US' ? titleEn : titleCn;
  
  // 如果已有标题，直接返回
  if (title) {
    return title;
  }
  
  // 如果没有 formatTitle，返回空字符串作为兜底
  if (!formatTitle) {
    return '';
  }
  
  // 使用 formatMessage 格式化 formatTitle
  return typeof formatTitle === 'string' 
    ? formatMessage({ id: formatTitle }) 
    : formatMessage(formatTitle);
};

/**
 * 对数据进行多条件排序
 * 1. 优先按 time 字段升序排序
 * 2. time 相同时，按 value 字段降序排序（无效值'-'或空值视为0）
 * 3. value 相同时，按 type 字段首字母升序排序（不区分大小写）
 * @param data 待排序的数据数组
 * @returns 排序后的新数组
 */
export const sortDataByTimeAndValue = (data: any[]) => (data || []).sort((a, b) => {
// 1. 按 time 升序排序
  if (a?.time < b?.time) return -1;
  if (a?.time > b?.time) return 1;
  // 2. time 相同时，按 value 升序降序
  const aValue = (a?.value === '-' || !(a?.value)) ? 0 : a?.value;
  const bValue = (b?.value === '-' || !(b?.value)) ? 0 : b?.value;
  const valueCompare =  parseFloat(bValue) - parseFloat(aValue);
  if (valueCompare !== 0) return valueCompare;

  // 3. value 相同时，按 type 的首字母升序排序（忽略大小写）
  const typeA = a?.type?.trim()?.toUpperCase();
  const typeB = b?.type?.trim().toUpperCase();

  if (typeA < typeB) return -1;
  if (typeA > typeB) return 1;
  return 0;
});


/**
* 根据 dataKey 获取数据
* @param dataKey - 数据键，可以是普通字符串或动态字符串格式（如 "{{spend.info}}"）
* @returns 解析后的数据
*/
export const getDataByKey = (dataKey: string, data: any): any => {
  if (!dataKey || !data) return undefined;
 
  // 如果是动态字符串格式（包含 {{}}）
  if (dataKey.includes('{{') && dataKey.includes('}}')) {
    const match = dataKey.match(/\{\{(.*?)\}\}/);
    if (match?.[1]) {
      // 切分属性路径和函数集合
      const [path] = match[1].split('|');
      // 使用 get 方法获取原始值
      // 注意：这里返回原始值，不进行字符串格式化
      return get(data, path?.trim(), undefined);
    }
  }
 
  // 普通字符串，直接使用
  return data[dataKey];
};